"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var Modal_1 = __importDefault(require("atomicComponents/organisms/Modal"));
var ModalContent_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalContent"));
var ModalFooter_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalFooter"));
var ModalHeader_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalHeader"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var XERO_APP_ID = 'a813670e-2d2e-4f6f-a2bb-351ed42223b8';
var XeroPricingModal = function (_a) {
    var _b;
    var company = _a.company, onClose = _a.onClose, subscription = _a.subscription;
    var _c = __read(react_1.default.useState(false), 2), linkClicked = _c[0], setLinkClicked = _c[1];
    react_1.default.useEffect(function () {
        if (subscription === null || subscription === void 0 ? void 0 : subscription.isActive) {
            onClose();
        }
    }, [subscription]);
    return ((0, jsx_runtime_1.jsxs)(Modal_1.default, __assign({ open: true, onClose: onClose, PaperProps: { sx: { maxWidth: 900 } } }, { children: [(0, jsx_runtime_1.jsx)(ModalHeader_1.default, { children: (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: "Choose your pricing plan" })) }), (0, jsx_runtime_1.jsxs)(ModalContent_1.default, __assign({ height: 700 }, { children: [(0, jsx_runtime_1.jsxs)("p", { children: ["You have signed up to Rechargly from Xero. You need to choose a subscription plan in their platform to finalise the setup", ' ', "and enable the first batch of invoices."] }), linkClicked && (0, jsx_runtime_1.jsx)("p", { children: "We are pending confirmation from Xero that you have selected a pricing plan." })] })), (0, jsx_runtime_1.jsx)(ModalFooter_1.default, { children: (0, jsx_runtime_1.jsxs)(Button_1.default, __assign({ href: "https://apps.xero.com/".concat((_b = company.xeroShortCodes) === null || _b === void 0 ? void 0 : _b[0], "/subscribe/").concat(XERO_APP_ID), onClick: function () { return setLinkClicked(true); } }, { children: ["Choose pricing plan ", linkClicked && '(Pending Xero confirmation)'] })) })] })));
};
exports.default = XeroPricingModal;
